export default __webpack_public_path__ + "static/instagram-7618c0fff7b3af6bac2af15c37f994c1.png";